export const firebaseConfig = {
  apiKey: "AIzaSyCT8gnhZ_xXALweOykekWEXf6sUV5Quabk",
  authDomain: "ok99-c929e.firebaseapp.com",
  projectId: "ok99-c929e",
  storageBucket: "ok99-c929e.appspot.com",
  messagingSenderId: "772467866482",
  appId: "1:772467866482:web:9a1dce88b4044f2b0cfbeb",
  measurementId: "G-QW8L5S7GVD",
};
